import React from 'react';
import './contact.css';
import Navbar from '../Menus/Navbar';
import Footer from '../Menus/Footer';

export default function Contact() {
  return (
    <>
      <Navbar />
      <section id="contact-section">
        <div className="contact-container">
          <div id="contact-info">
            <h2>Contact Us</h2>
            <p><strong>Phone:</strong> <a href="tel:+919342851992">+919342851992</a></p>
          </div>

          <div id="opening-hours">
            <h3>Opening Hours</h3>
            <p>Monday - Sunday: <strong>9:00 AM - 9:00 PM</strong></p>
          </div>

          <div id="special-service">
            <h3>Our Special Service</h3>
            <p>We provide doorstep repairing services for all major home appliances, ensuring fast and efficient solutions for your convenience.</p>
          </div>

          <div id="why-choose-us">
            <h3>Why Choose Us?</h3>
            <p>At <strong>Home Appliance Assist</strong>, we prioritize customer satisfaction by offering reliable, affordable, and professional services. Our expert technicians are always ready to help you with any appliance issues, ensuring your home runs smoothly.</p>
          </div>
        </div>

        <div id="tn-map-section">
          <h3>We Serve All Over Tamil Nadu</h3>
          <p>From Madurai to Chennai, Trichy to Coimbatore — our technicians are available across all major districts of Tamil Nadu. Call us now for fast and professional doorstep service.</p>

          {/* Embedded Tamil Nadu Map (Google Maps centered on TN) */}
          <div className="map-responsive">
            <iframe
              title="Tamil Nadu Service Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6286374.098423939!2d76.10993969216499!3d10.909433823635844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00c5d6c9faea1b%3A0xe52a15ab29e7a4df!2sTamil%20Nadu!5e0!3m2!1sen!2sin!4v1694890198363!5m2!1sen!2sin"
              width="100%"
              height="350"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        <div id="extra-info-section">
          <h3>Service Highlights</h3>
          <ul>
            <li>✅ Quick response and doorstep service</li>
            <li>✅ Verified and experienced technicians</li>
            <li>✅ Affordable pricing with warranty support</li>
            <li>✅ Support for all major appliance brands</li>
          </ul>
        </div>
      </section>
      <Footer />
    </>
  );
}
